module.exports = __webpack_public_path__ + "static/img/LeveManfred_MaciunasGeorge_DripMusic-Dusseldorf1_1963.b61cc95.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/data/brecht/images/LeveManfred_MaciunasGeorge_DripMusic-Dusseldorf1_1963.jpg
// module id = BjE2
// module chunks = 0